export const SearchPlaceholder = "LzD7wb";
export const SearchAriaLabel = "$LUmge";
export default {SearchPlaceholder,SearchAriaLabel};